<script setup lang="ts">

import {store} from '../../store/Store';
import {connectWallet} from "../../lib/Wallet";
import {ref, watch} from "vue";

const errorText = ref('');
const enabled = ref(false);

watch(() => store.web3Onboard, () => {
  enabled.value = store.web3Onboard != null;
});

const connect = async () => {
  await connectWallet();
}
const providerError = (e) => {
  console.log('providerError', e);
  errorText.value = 'Wallet is not connected; please try again';
}
</script>

<template>
  <div>
    <div v-if="store.walletIsConnected"><!-- wallet is connected --></div>
    <div v-else>
      <div>
        <button id="onboardBtn" class="button_onboard" :disabled="!enabled" @click="connect">Connect to Wallet</button>
      </div>
      <div>{{ errorText }}</div>
    </div>
  </div>
</template>

<style scoped>
</style>